import { Button } from "primereact/button";

type WaybillButtonProps = {
  deliveryStatus: string;
  rowId: number;
};

export default function WaybillButton({ deliveryStatus }: WaybillButtonProps) {
  const isWaybillAvailable = [
    "APPROACHING_DESTINATION",
    "IN_DESTINATION",
    "CONFIRMED",
  ].includes(deliveryStatus);

  const handleWaybillOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    window.open("../assets/example_waybill.pdf", "_blank"); // Open in new tab
  };

  if (!isWaybillAvailable) {
    return null;
  }

  return (
    <>
      <Button
        icon="pi pi-file-pdf"
        text
        rounded
        aria-label="Pokaż list przewozowy"
        title="Pokaż list przewozowy"
        onClick={handleWaybillOpen}
      />
    </>
  );
}
